import { getMessage } from '@tcc/i18n';
import { Button, ButtonFill, ComponentColor, Dialog, DialogContent, DialogFooter, DialogWidth, Spinner, Typography, TypographyVariant } from '@tcc/fds';

type DeleteConfirmationModalProps = {
  confirmTitleKey: string;
  removeAllComments: () => void,
  isLoading: boolean,
  handleClickCancel: () => void,
};

export const DeleteConfirmationModal = ({
  confirmTitleKey,
  removeAllComments,
  isLoading,
  handleClickCancel,
}: DeleteConfirmationModalProps) => (
    <Dialog
      testId='region-note-form-delete-confirmation-modal'
      key='region-note-form-delete-confirmation-modal'
      onOpenChange={handleClickCancel}
      defaultOpen
      open
      isModal
      width={DialogWidth.Wide}
      closeOnOutsideClick={false}
      headerProps={{
        showCloseButton: true,
        title: getMessage('regions.report.modal.title')
      }}>
    <DialogContent>
      <Typography variant={TypographyVariant.Heading}>
        { getMessage('deleteConfirmationModal.title') }
      </Typography>
    </DialogContent>
    <DialogFooter>
      <Button
        testId='confirmation-modal-go-back-button'
        onClick={handleClickCancel}
        fill={ButtonFill.Outline}
        color={ComponentColor.Primary}
        disabled={isLoading}
        >
          {isLoading ? ( <Spinner /> ) : getMessage('confirmationModal.goBack')}
      </Button>
      <Button
        testId='confirmation-modal-confirm-button'
        onClick={() => removeAllComments()}
        fill={ButtonFill.Solid}
        color={ComponentColor.Error}
        disabled={isLoading}>
          {isLoading ? ( <Spinner /> ) : getMessage(confirmTitleKey) }
      </Button>
    </DialogFooter>
    </Dialog>
  )